
import { LOAD_TRACK_CASH_REQUEST_APPROVALS } from './actions';



export const trackCashRequestApprovals = (state={},action)=>{
    const {type,payload}=action;
    switch (type) {
        case LOAD_TRACK_CASH_REQUEST_APPROVALS:
            return {...payload}
        default: 
            return state;
    }
}